import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, withKeys as _withKeys, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_ctx.visible)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            onMousedown: _cache[0] || (_cache[0] =
                //@ts-ignore
                (...args) => (_ctx.closeModalOnClickOutside && _ctx.closeModalOnClickOutside(...args))),
            onKeyup: _cache[1] || (_cache[1] = _withKeys(
            //@ts-ignore
            (...args) => (_ctx.closeModalOnEscapeKey && _ctx.closeModalOnEscapeKey(...args)), ["esc"]))
        }, [
            _createVNode(_Transition, {
                name: "g-fade",
                appear: ""
            }, {
                default: _withCtx(() => [
                    _createElementVNode("div", {
                        class: _normalizeClass(['g-modal-popup', _ctx.modalClasses]),
                        ref: "modal"
                    }, [
                        _createElementVNode("div", {
                            class: _normalizeClass(['dialog', _ctx.identifierClass]),
                            ref: "dialog",
                            tabindex: "-1"
                        }, [
                            _renderSlot(_ctx.$slots, "default")
                        ], 2)
                    ], 2)
                ]),
                _: 3
            })
        ], 32))
        : _createCommentVNode("", true);
}
